export function appendDateTimestamp(date?: string) {
  return date ? `${date}T00:00:00.000Z` : null;
}
